import logger from "utils/logger";

// The invitation key of a signed-out user who clicked "Sign in to accept".
// Kept in sessionStorage because SignIn clears localStorage before signing in;
// completeSignIn takes it and sends the user back to the invitation.
const KEY = "pendingInvitation";

const pendingInvitation = {
  set(invitationKey: string): void {
    try {
      sessionStorage.setItem(KEY, invitationKey);
    } catch (err) {
      logger.error(err);
    }
  },

  take(): string | null {
    try {
      const value = sessionStorage.getItem(KEY);
      sessionStorage.removeItem(KEY);
      return value;
    } catch (err) {
      logger.error(err);
      return null;
    }
  },
};

export default pendingInvitation;
